import SchemaHandler from '@exp/exp-utils/schema/schemaHandler';

import { getVariantId } from '../../splitio/splitio';

class GetVariantForExperimentHandlerV1 extends SchemaHandler { // eslint-disable-line id-length

  process() {
    super.process({
      ALL: (input) => { this._handleSplitio(input); }
    });
  }

  _handleSplitio(input) {
    getVariantId(input.experiment_id, input.attributes, input.traffic_type, input.configuration, ((variantId) => {
      input.callback(variantId);
    }).bind(this));
  }
}

export default GetVariantForExperimentHandlerV1;
